export enum ManagerFilterType {
  MANAGER_TYPE = 'MANAGER_TYPE',
  CUSTOM = 'CUSTOM',
}
